import { create } from "zustand";
import type { DocumentsStore } from "./types";
import {
    getAllIngestedFiles,
    deleteFile,
    downloadPdf,
    changeMetadata,
    changeBulkMetadata,
} from "../../../api";
import { asyncActionWrapper } from "../utils/asyncActionWrapper";


export const useDocumentsStore = create<DocumentsStore>((set, get) => ({
    loading: false,
    documents: [],
    asyncActionWrapper,
    fetchDocuments: async () => {
        set({ loading: true });
        set({ documents: await getAllIngestedFiles() });
        set({ loading: false });
    },
    deleteFileWrapper: async (fileId: string[]) => {
        await get().asyncActionWrapper(
            async () => {
                await Promise.all(fileId.map(id => deleteFile(id)));
                get().fetchDocuments();
            },
            `Files ${fileId.join(", ")} deleted successfully`,
            `Error deleting files ${fileId}`
        );
        get().fetchDocuments();
    },
    downloadFileWrapper: async (url: string, filename: string) => {
        await get().asyncActionWrapper(
            async () => {
                await downloadPdf(url, filename);
            },
            `File ${filename} downloaded successfully`,
            `Error downloading file ${filename}`
        );
    },
    changeMetadataWrapper: async (selectedItem: { url: string }, value: { metadata: any, validFrom: string, validTo: string }) => {
        await get().asyncActionWrapper(
            async () => {
                await changeMetadata(
                    selectedItem.url,
                    value.metadata,
                    [],
                    value.validFrom,
                    value.validTo
                );
            },
            `Metadata for ${selectedItem.url} changed successfully`,
            `Error changing metadata for ${selectedItem.url}`
        );
        get().fetchDocuments();
    },
    changeMetadataBulk: async (json: any) => {
        await get().asyncActionWrapper(
            async () => {
                await changeBulkMetadata(json);
            },
            `Metadata for bulk changed successfully`,
            `Error changing metadata for bulk`
        );
        get().fetchDocuments();
    },

}));
